module.exports = __webpack_public_path__ + "img/avani-avenida-liberdade.48ca896b.jpg";